import { render, staticRenderFns } from "./tips-dialog.vue?vue&type=template&id=6b0ad3a4&scoped=true"
import script from "./tips-dialog.vue?vue&type=script&lang=ts"
export * from "./tips-dialog.vue?vue&type=script&lang=ts"
import style0 from "./tips-dialog.vue?vue&type=style&index=0&id=6b0ad3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ad3a4",
  null
  
)

export default component.exports